<template>
  <status-template
    :title="$t('title')"
    :imageUrl="require(`@/assets/kyc/step_qr_code_1.svg`).default"
  >
    <template #description>
      <jade-text variant="text-medium">
        {{ $t('description-1') }}
        <b>{{ $t('description-2') }}</b>
        {{ $t('description-3') }}
      </jade-text>
    </template>

    <template #trailing>
      <jade-alert
        v-if="error"
        class="alert"
        variant="negative"
        show-icon
      >
        <jade-text color="negative">
          {{ $t('error-alert') }}
        </jade-text>
      </jade-alert>
      <generate-link-button
        :id="id"
        @error="handleGenerateLinkError"
        @generating="handleGenerating"
      />
    </template>
  </status-template>
</template>

<script>
import JadeText from '@jade/JadeText/index.vue'
import JadeAlert from '@jade/JadeAlert/index.vue'

export default {
  name: 'PartiallyDenied',
  components: {
    StatusTemplate: () => import('./StatusTemplate.vue'),
    GenerateLinkButton: () => import('../GenerateLinkButton.vue'),
    JadeAlert,
    JadeText
  },
  data () {
    return {
      error: false
    }
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  methods: {
    handleGenerateLinkError () {
      this.error = true
    },
    handleGenerating () {
      this.error = false
    }
  }
}
</script>
<style scoped>
@import '@stone-payments/jade-design-tokens/pagarme/space.css';
.alert {
  width: 100%;
  margin-bottom: var(--global-space-300);
}
</style>
<i18n>
  {
    "pt-BR": {
      "title": "Ative a movimentação do saldo deste recebedor",
      "description-1": "Crie e envie um link para o recebedor liberar a ",
      "description-2": "movimentação do saldo.",
      "description-3": "Avise antes de enviar, o link é válido por 20 minutos!",
      "error-alert": "Não foi possível criar o link. Tente outra vez."
    },
    "en-US": {
      "title": "Activate the balance movement of this recipient",
      "description-1": "Create and send the link so the recipiente can unfreeze the ",
      "description-2": "balance movement.",
      "description-3": "Give it a heads up before sending, the link is only valid for 20 minutes!",
      "error-alert": "There was an error generating your link. Try again."
    }
  }
</i18n>
